import axios from 'axios';

// In development, prefer same-origin `/api` so CRA proxy can avoid CORS/XHR issues (e.g. PDF downloads).
const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? '/api' : 'http://localhost:5000/api');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    // Don't add Authorization header for login/signup endpoints
    const isAuthEndpoint = config.url?.includes('/auth/login') || 
                          config.url?.includes('/auth/admin/login') ||
                          config.url?.includes('/auth/practitioner/signup') ||
                          config.url?.includes('/auth/patient/signup');
    
    if (!isAuthEndpoint) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log network errors for debugging
    if (!error.response) {
      console.error('Network Error:', {
        message: error.message,
        code: error.code,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          baseURL: error.config?.baseURL,
          headers: error.config?.headers,
        },
      });
      
      // Check if it's a network/CORS error
      if (error.message.includes('Network Error') || error.message.includes('CORS') || error.code === 'ERR_NETWORK') {
        console.error('❌ Network/CORS Error - Check:');
        console.error('1. Backend server is running');
        console.error('2. API URL is correct:', error.config?.baseURL);
        console.error('3. CORS is properly configured');
        console.error('4. Ngrok URL is active and correct');
        console.error('5. Full request URL:', error.config?.baseURL + error.config?.url);
        console.error('6. Request method:', error.config?.method);
      }
    }
    
    if (error.response?.status === 401) {
      // Only redirect if we're not already on a login page
      // Don't redirect for login/signup requests as they handle their own errors
      const isLoginRequest = error.config?.url?.includes('/auth/login') || 
                            error.config?.url?.includes('/auth/admin/login') ||
                            error.config?.url?.includes('/auth/practitioner/signup') ||
                            error.config?.url?.includes('/auth/patient/signup');
      
      const isOnLoginPage = window.location.pathname === '/login' || 
                           window.location.pathname === '/admin-login' ||
                           window.location.pathname === '/signup';
      
      // Only redirect if it's not a login/signup request and we're not on a login page
      if (!isLoginRequest && !isOnLoginPage) {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        // Use window.location only if not in React Router context
        // Otherwise, let the component handle navigation
        if (window.location.pathname.startsWith('/admin/dashboard') || 
            window.location.pathname.startsWith('/practitioner/dashboard') ||
            window.location.pathname.startsWith('/patient/dashboard')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;

